import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { shareReplay } from "rxjs/operators";

export interface IPaisDialCode {
    code: string
    name: string,
    dialCode: string,
    urlImage: string
}

@Injectable({
    providedIn: "root",
})
export class TelefoneIntlService {
    private paises$: Observable<Array<IPaisDialCode>>

    constructor(
        private http: HttpClient
    ) {
        //realiza a carga do json apenas uma unica vez
        this.paises$ = this.http.get<Array<IPaisDialCode>>('assets/data/paises/paises.json').pipe(shareReplay(1))
    }
 
    getPaises(): Observable<Array<IPaisDialCode>> {
        return this.paises$
    }
}
